import React from 'react'
import ReactDOM from 'react-dom'
import './fonts/fonts.css'
import './index.css'
import { App } from './App'
import { BrowserRouter } from 'react-router-dom'

// Disable mouse wheel on number inputs globally
document.addEventListener(
  'wheel',
  (e: WheelEvent) => {
    const target = e.target as HTMLElement
    if (target && target instanceof HTMLInputElement && target.type === 'number') {
      if (document.activeElement === target) {
        target.blur()
      }
    }
  },
  { passive: true }
)

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
)
